export let activityTag = {
	bindings: {
		activity       : '<',
		selected       : '<',
		notShowCheckbox: '<',
	},
	template: `
      <div ng-if="!vm.tagHtmltag(vm.activity)"   
        class="activityTag font-bold text-block m-h-sm m-b-sm" 
        ng-class="vm.tagClass(vm.activity)" >
        {{ vm.activity.tagName }}
      </div>

      <div ng-if="vm.activity.isForPlan === 0" 
        class="activityTag font-bold text-block morado m-h-sm m-b-sm">
        Sin planear
      </div>

      <div ng-if="vm.tagHtmltag(vm.activity)"   
        class="activityTag font-bold text-block m-h-sm m-b-sm" 
        ng-class="vm.tagClass(vm.activity)">
        {{ vm.activity.tagName }}
      </div>
      <div ng-if="vm.tagHtmltag(vm.activity) && !vm.notShowCheckbox" 
        class="clearfix text-xxs font-bold m-t-sm leftActivityDetailsCheck">
        <span class="text-negro-dark">
          Ejecutar asignatura
        <label class="m-l-xs md-check">
        <input type="checkbox" 
          ng-model="vm.cb1" 
          aria-label="Checkbox 1"  
          ng-click="vm.toggle(vm.activity)" 
          ng-disabled="vm.validateExecuteSubject(vm.activity)">
          <i class="verde"></i>
        </label>
        </span>
      </div>`,
	controllerAs: 'vm',
	controller  : [ '$stateParams', '$scope', '$state', 'Validations', 'Ramda', '$mdDialog', 'WorkPlanModalSrv', 
		'$cookies', 'ReviewSrv', 'CssClasses', 'GlobalConfig',
		function activitiesListCtrl ($stateParams, $scope, $state, Validations, Ramda, $mdDialog, 
			WorkPlanModalSrv, $cookies, ReviewSrv, CssClasses, GlobalConfig) {
			const { curry } = Ramda
			const {
				isActivitiesType,
				isCommitteeParticipationType,
				isTeacherDevelopmentType,
				isProjectsType,
				isSubjectType,
				isPositionByDelegationType,
				isDoctoralEducationType,
				isProjectDesignType,
				isStudentAttentionType,
				isOtherActivitiesType,
				isCommunityType,
				isProductsType,
				isRolesType,
				isInvestigationType,
				isResultsTransferType,
				isColaborationSpaceType,
				isInternalProjectsFormulationType,
				isExtensionProjectsType,
				isVisibilityType,
				isConsultancyType,
				isShortCoursesType,
				isCrossProjectFormulationType,
				isCrossExtensionProjectsType,
			} = Validations

			const is = {
				blue: (activity) => {
					return isActivitiesType(activity) ||
                isCommitteeParticipationType(activity) ||
                isTeacherDevelopmentType(activity) ||
                isProjectsType(activity) ||
                isInternalProjectsFormulationType(activity)
				},
				green: (activity) => {
					return isSubjectType(activity) ||
                isPositionByDelegationType(activity) ||
                isDoctoralEducationType(activity) ||
                isProjectDesignType(activity) ||
                isExtensionProjectsType(activity)
				},
				purple: (activity) => {
					return isStudentAttentionType(activity) ||
                isOtherActivitiesType(activity) ||
                isCommunityType(activity) ||
                isProductsType(activity) ||
                isCrossProjectFormulationType(activity)
				},
				gray: (activity) => {
					return isRolesType(activity) ||
                isInvestigationType(activity) ||
                isVisibilityType(activity)
				},
				cyan: (activity) => {
					return isResultsTransferType(activity) ||
                isConsultancyType(activity)
				},
				red: (activity) => {
					return isColaborationSpaceType(activity) ||
                isCrossExtensionProjectsType(activity)
				},
				yellow: (activity) => {
					return isShortCoursesType(activity)
				},
			}

			const tagClass = curry((is, activity) => {
				switch (true) {

				case is.green(activity):
					return 'verde'
				case is.blue(activity):
					return 'azul'
				case is.gray(activity):
					return 'gris-dark'
				case is.purple(activity):
					return 'morado'
				case is.cyan(activity):
					return 'cian-light'
				case is.red(activity):
					return 'rojo'
				case is.yellow(activity):
					return 'amarillo'
				
				}
			})(is)

			const tagHtmltag = curry((scope, is, activity) => {
				// if (activity.executionFinish !== 1) scope.cb1 = Boolean(activity.isExecution)
				if (activity.executionFinish !== 1) scope.cb1 = Boolean((activity.origin == 3 && activity.checkStatus == 1))

				if (isSubjectType(activity) && activity.origin === 3) {
					return true
				}

				return false
			})(this, is)

			const toggle = activity => {
				if (this.activity.checkStatus == true) {
					this.cb1 = false
				} else {
					this.cb1 = true
				}

				this.activity.checkStatus = this.cb1
				// WorkPlanModalSrv.setupActivity(this, activity)
				var THIS = this
      
				if (this.cb1 == true) {
					$mdDialog.show({
						controller: [ '$scope', '$mdDialog', '$state', 'ReviewSrv', '$rootScope', '$timeout', function ($scope, $mdDialog, $state, ReviewSrv, $rootScope, $timeout) {
							$scope.buttonFlagSave = false
							$scope.alertModule = close
                  
							$timeout(function() {
								$('body .md-icon-button').addClass('closebuttonremove')
								$('.closebuttonremove').hide()
							}, 100)
                
							// $scope.buttonFlagCancel=true
							$scope.save = () => {
								THIS.activity.checkStatus = THIS.cb1
								$scope.buttonFlagSave = true
								// $scope.buttonFlagCancel=false

								// let header = {id_code: activity.workplanTeacherActivityId}
								var param = { activityId               : THIS.activity.activityId,
									workplanTeacherActivityId: THIS.activity.workplanTeacherActivityId }

								ReviewSrv.addCustomActivity.updateAssignaturestatus(param).$promise.then(dataReturn => {
									$mdDialog.hide()
									$scope.buttonFlagSave = false
									$rootScope.$broadcast('selectActivityEmit', THIS.activity)
								})
							}

							$scope.close = () => {
								THIS.cb1 = false
								$scope.buttonFlagSave = true
								THIS.activity.checkStatus = THIS.cb1
								// $scope.buttonFlagSave=true
								$rootScope.$broadcast('selectActivityEmit', THIS.activity)
								$mdDialog.hide()
							}  

							$scope.alertModule = () => {
								THIS.cb1 = false
								$scope.buttonFlagSave = true
								THIS.activity.checkStatus = THIS.cb1
								// $scope.buttonFlagSave=true
								$mdDialog.hide()
							}
						} ],
						// template: '<div ng-include="setupErrorModal"><div>',
						template           : require('./checkboxTrueDialogModal.html'),
						clickOutsideToClose: false,
						escapeToClose      : false,
					})
				} else {
					$mdDialog.show({
						controller: [ '$scope', '$mdDialog', '$state', 'ReviewSrv', '$rootScope', '$timeout', function ($scope, $mdDialog, $state, ReviewSrv, $rootScope, $timeout) {
							$scope.buttonFlagSave = false

							$timeout(function() {
								$('body .md-icon-button').addClass('closebuttonremove')
								$('.closebuttonremove').hide()
							}, 100)
                 
							$scope.save = () => {
								THIS.activity.checkStatus = THIS.cb1
								$scope.buttonFlagSave = true
								$scope.alertModule = close
								// let header = {id_code: activity.workplanTeacherActivityId}
								var param = { activityId               : THIS.activity.activityId,
									workplanTeacherActivityId: THIS.activity.workplanTeacherActivityId }

								ReviewSrv.addCustomActivity.updateAssignaturestatus(param).$promise.then(dataReturn => {
									// $scope.close()
									$scope.buttonFlagSave = false
									$mdDialog.hide()
									$rootScope.$broadcast('selectActivityEmit', THIS.activity)
								})
							}

							$scope.close = () => {
								THIS.cb1 = true
								THIS.activity.checkStatus = THIS.cb1
								$scope.buttonFlagSave = true
								$rootScope.$broadcast('selectActivityEmit', THIS.activity)
								$mdDialog.hide()
							}

							$scope.alertModule = () => {
								THIS.cb1 = true
								THIS.activity.checkStatus = THIS.cb1
								$scope.buttonFlagSave = true
								$mdDialog.hide()
							}  
						} ],
						// template: '<div ng-include="setupErrorModal"><div>',
						template           : require('./checkboxFalseDialogModal.html'),
						clickOutsideToClose: false,
					})
				}
			}

			const executionFinishVal = teacherId => {
				return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: teacherId }).$promise.then(dataReturn => {
					return dataReturn.status ? dataReturn.data.wokplanTeacherStatus[0].executionFinish : 0
				})
			}

			const validateExecuteSubject = activity => {
				const roleId = $cookies.get('hasRoleId')
				const approvedFinish = $cookies.get('workplan-approvedFinish')
				const executionFinish = $cookies.get('workplan-executionFinish')

				if (
					activity.executionFinish !== 1 && 
        roleId == GlobalConfig.userRolesIds.teacher &&
        approvedFinish == 1 &&
        executionFinish != 1
				)
					return false

				return true
			}

			angular.extend(this, {
				cb1               : false,
				disabled          : false,
				tagClass          : tagClass,
				tagHtmltag        : tagHtmltag,
				toggle            : toggle,
				validateExecuteSubject,
				executionFinishVal: executionFinishVal,
				executionFinish   : Boolean($cookies.get('executionFinish')),
				roleIdDisabled    : false,
			})

			this.$onInit = () => {
				let currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage

				this.disabled = Boolean(Validations.inReviewExecution(currentStage))
				this.roleIdDisabled = false

				if (Boolean($cookies.get('executionFinish')) && (($cookies.get('hasRoleId') != GlobalConfig.userRolesIds.teacher))) {
					this.roleIdDisabled = true
				}
			}
		},
	] }


// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activities-list/activity-tag.js